import type { AdvisoryBriefDocumentInputV01 } from './types';

const preparedAnswers: AdvisoryBriefDocumentInputV01['answers'] = [
  {
    questionId: 'strategic-synthesis',
    question: 'What is the prepared strategic decision?',
    status: 'answered',
    readOrder: 1,
    answerText:
      'Prepared narrative for the source-register preview. It is neutral demonstration content, not a live advisory answer.',
    citations: [
      {
        canonicalId: 'answer-decision-brief-01',
        compositeId: 'answer-decision-brief-01#page=5',
        kind: 'document',
        source: 'Decision constraints note',
        docId: 'answer-decision-brief',
        chunkId: 'chunk-05',
        docTitle: 'Decision constraints note',
        pageRange: [5, 5],
        origin: 'retrieved',
      },
    ],
    rendering: {},
  },
  {
    questionId: 'go-no-go',
    question: 'What should be tested before a commitment?',
    status: 'answered',
    readOrder: 2,
    answerText: 'Prepared narrative for an option and test decision.',
    rendering: {},
  },
  {
    questionId: 'market-attractiveness',
    question: 'Where is the prepared opportunity?',
    status: 'answered',
    readOrder: 3,
    answerText: 'Prepared narrative for an opportunity comparison.',
    rendering: {},
  },
  {
    questionId: 'right-to-win',
    question: 'Which capability warrants attention?',
    status: 'answered',
    readOrder: 4,
    answerText: 'Prepared narrative for a capability assessment.',
    rendering: {},
  },
  {
    questionId: 'business-model-fit',
    question: 'Which operating-model question remains?',
    status: 'answered',
    readOrder: 5,
    answerText: 'Prepared narrative for a business-model review.',
    rendering: {},
  },
];

/**
 * Network-free provenance preview. Source names, identifiers, and all chapter
 * text are prepared neutral examples; they do not describe a live engagement.
 */
export const PREPARED_PROVENANCE_GROWTH_STRATEGY_FIXTURE: AdvisoryBriefDocumentInputV01 = {
  engagementId: 'growth-strategy',
  engagementLabel: 'Growth Strategy',
  projectLabel: 'Prepared provenance fixture',
  title: 'Source register preview',
  subtitle:
    'Prepared fixture — source cards demonstrate the GChat provenance UI. The opening research is separate from answer evidence.',
  prepared: true,
  researchContextStatus: 'ready',
  researchContext: {
    claimResolution: { state: 'sourced' },
    register: {
      citationsOnWire: 4,
      truncated: true,
      malformedSources: 0,
      sources: [
        {
          key: 'research-market-baseline-01',
          id: 'research-market-baseline-01',
          kind: 'document',
          locator: null,
          canonicalId: 'research-market-baseline-01',
          compositeId: 'research-market-baseline-01#page=8',
          documentId: 'research-market-baseline',
          chunkId: 'chunk-08',
          title: 'Regional market baseline',
          pageRange: [8, 9],
          collectionIds: ['prepared-research'],
          origin: 'retrieved',
        },
        {
          key: 'research-capacity-model-02',
          id: 'research-capacity-model-02',
          kind: 'document',
          locator: null,
          canonicalId: 'research-capacity-model-02',
          compositeId: 'research-capacity-model-02#page=14',
          documentId: 'research-capacity-model',
          chunkId: 'chunk-14',
          title: 'Operating capacity model',
          pageRange: [14, 14],
          collectionIds: ['prepared-research'],
          origin: 'computed',
        },
        {
          key: 'research-unknown-origin-03',
          id: 'research-unknown-origin-03',
          kind: 'document',
          locator: null,
          canonicalId: null,
          compositeId: 'research-unknown-origin-03#page=3',
          documentId: 'research-unknown-origin',
          chunkId: null,
          title: null,
          pageRange: null,
          collectionIds: null,
          origin: 'unknown',
        },
      ],
    },
  },
  answers: preparedAnswers,
};
